import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { painPoints } from "../../data/content";
export function PainPoints() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" aria-label="Common frustrations" data-id="element-223" data-mp="27m26vfzs5l74">
      <div className="mx-auto max-w-5xl" data-id="element-224" data-mp="22vlv00bly7mv">
        <SectionHeading title={<>If you've ever looked at a new case and thought…</>} data-id="element-225" data-mp="22usisjtvqpxc" />

        <div className="grid gap-4 md:grid-cols-2" data-id="element-226" data-mp="2hjf91gl1p23c">
          {painPoints.map(p => <article key={p.quote} className="flex gap-4 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-navy/5" data-id="element-227" data-mp="2clngckcktby3">
              <div className="mt-1 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-228" data-mp="2qlg5wccd9m4h" />
              <div data-id="element-229" data-mp="2mjums998oblu">
                <h3 className="font-serif text-xl font-bold italic leading-snug text-ink" data-id="element-230" data-mp="2mjbap969shfq">“{p.quote}”</h3>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-231" data-mp="w86rc64yrafd">{p.detail}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-4 text-center text-lg leading-relaxed text-ink/85" data-id="element-232" data-mp="s7msmy4qryr4">
          <p data-id="element-233" data-mp="1n5z2gyoxdzap">And I understand that frustration. I've experienced the difference between knowing something and being able to organize your thinking when looking at a new case.</p>
          <p className="font-serif text-2xl font-bold text-navy" data-id="element-234" data-mp="1x4ojkp8zzfpw">That's exactly the gap the Decision Lab™ addresses.</p>
        </div>

        <CtaButton label="I want a structured way to practice" className="mt-8" data-id="element-235" data-mp="26w2ojcjpx7qf" />
      </div>
    </section>;
}